export enum InjectableInterfaces {
    ICanvasScaler = "ICanvasScaler",
    IPackageRegistrator = "IPackageRegistrator",
    IGameDistributionSdk = "IGameDistributionSdk"
}